import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ContentRecentSearches" */'@modals/partials/RecentSearches'));
